import { Check, Star } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { SERVICE_LADDER } from "@/lib/content";

export default function ServicesLadder() {
  return (
    <section className="section-pad" data-testid="home-services">
      <div className="container-sp">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="overline">Services · value ladder</div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#0D1B2A] mt-3 leading-tight max-w-2xl">
              From first question to full relocation — at your pace.
            </h2>
          </div>
          <p className="text-[#4A5568] max-w-md">
            Grouped by visitor intent, not our internal structure. Start wherever
            you are — we'll meet you there.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {SERVICE_LADDER.map((tier, idx) => {
            const isDark = tier.accent === "dark";
            const isFeatured = tier.featured;
            return (
              <motion.div
                key={tier.tier}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: idx * 0.08 }}
                className={`relative rounded-2xl p-8 md:p-10 border ${
                  isDark
                    ? "bg-[#0D1B2A] text-white border-[#1B2A3D]"
                    : isFeatured
                    ? "bg-[#EBE9E1] text-[#0D1B2A] border-[#D5D3C5]"
                    : "bg-white text-[#0D1B2A] border-[#EFEEE8]"
                }`}
                data-testid={`service-tier-${idx}`}
              >
                {isFeatured && (
                  <span className="absolute -top-3 left-8 inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-[0.2em] bg-[#D7141A] text-white px-3 py-1.5 rounded-full">
                    <Star className="w-3 h-3" /> {tier.badge}
                  </span>
                )}
                {!isFeatured && (
                  <div className={`overline ${isDark ? "text-[#E5444A]" : ""}`}>
                    {tier.badge}
                  </div>
                )}

                <h3 className="font-serif text-2xl mt-3">{tier.tier}</h3>
                <div
                  className={`text-sm mt-1 ${
                    isDark ? "text-white/60" : "text-[#718096]"
                  }`}
                >
                  {tier.price}
                </div>

                <ul className="mt-7 space-y-3">
                  {tier.items.map((it) => (
                    <li key={it} className="flex items-start gap-2.5 text-sm">
                      <Check
                        className={`w-4 h-4 mt-0.5 shrink-0 ${
                          isDark ? "text-[#E5444A]" : "text-[#D7141A]"
                        }`}
                      />
                      <span className={isDark ? "text-white/85" : "text-[#4A5568]"}>
                        {it}
                      </span>
                    </li>
                  ))}
                </ul>

                <Link
                  to={tier.ctaHref.startsWith("#") ? `/${tier.ctaHref.replace("#", "contact#")}` : tier.ctaHref}
                  data-testid={`service-cta-${idx}`}
                  className={`mt-10 inline-flex items-center justify-center w-full rounded-full px-6 py-3.5 font-medium text-sm transition-all ${
                    isDark
                      ? "bg-[#D7141A] hover:bg-[#B5111A] text-white"
                      : isFeatured
                      ? "bg-[#0D1B2A] hover:bg-[#1B2A3D] text-white"
                      : "border border-[#0D1B2A] text-[#0D1B2A] hover:bg-[#0D1B2A] hover:text-white"
                  }`}
                >
                  {tier.cta}
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
